"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GRAPHQL_ENTITLEMENTS_GATEWAY_BASE_URL = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _constants = require("../constants");

var _createWorkflowAppolloClient = _interopRequireDefault(require("../utils/createWorkflowAppolloClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query getAppTimeOut($type1: String) {\n    getAppTimeOut(appShortKey: $type1) {\n      timeout\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GRAPHQL_ENTITLEMENTS_GATEWAY_BASE_URL = process.env.NODE_ENV === "production" ? "/apollo_gateway" + _constants.servicegraphql : _constants.servicebasepath + "/apollo_gateway" + _constants.servicegraphql;
exports.GRAPHQL_ENTITLEMENTS_GATEWAY_BASE_URL = GRAPHQL_ENTITLEMENTS_GATEWAY_BASE_URL;
var client = (0, _createWorkflowAppolloClient.default)(GRAPHQL_ENTITLEMENTS_GATEWAY_BASE_URL, {
  appName: "UMU"
});
var GET_APP_TIMEOUT = (0, _graphqlTag.default)(_templateObject());

var TimeoutService = /*#__PURE__*/function () {
  function TimeoutService() {
    _classCallCheck(this, TimeoutService);
  }

  _createClass(TimeoutService, null, [{
    key: "getAppTimeout",
    value: function getAppTimeout(appShortKey) {
      return client.query({
        query: GET_APP_TIMEOUT,
        variables: {
          type1: appShortKey
        }
      });
    }
  }]);

  return TimeoutService;
}();

var _default = TimeoutService;
exports.default = _default;